import React, { FC } from 'react'
import { getDate } from 'date-fns'

import css from './apolloDayPicker.module.scss'
import { Icon } from '@ui'
import { DayPicker, DayPickerProps, DayContentProps } from 'react-day-picker'

const ApolloDayPicker: FC<DayPickerProps> = (props) => (
  <div className={css.wrapper}>
    <DayPicker
      {...props}
      components={{
        ...props.components,
        DayContent: (props: DayContentProps) => (
          <span className={css.rdp_day_content}>{getDate(props.date)}</span>
        ),
        IconLeft: () => <Icon name="chevron-left" />,
        IconRight: () => <Icon name="chevron-right" />,
      }}
    />
  </div>
)

export default ApolloDayPicker
